import { render } from "./CartFormRequest.vue?vue&type=template&id=b8ab4ddc&scoped=true"
import script from "./CartFormRequest.vue?vue&type=script&lang=js"
export * from "./CartFormRequest.vue?vue&type=script&lang=js"

import "./CartFormRequest.vue?vue&type=style&index=0&id=b8ab4ddc&scoped=true&lang=css"

import exportComponent from "/Users/mattia/Desktop/Projects/elbi-website-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8ab4ddc"]])

export default __exports__